<template>
	<div>
	<div class="row">
		<div class="col-md-8">
			<div class="row mb-4">
				<div class="col-md-6">
					<ListCompare title="SALES" unit="KL" comp=1 :data="ytd.sales" itemcol="Info" valuecol="Value"
						:url="'/fuel/report2?tab=0&plant=' + plant + '&' + this.getYTDfilter('dateStart', 'dateEnd') + '&detail1=station'"/>
				</div>
				<div class="col-md-6">
					<ListCompare title="LOSSES" unit="%" comp=-1 :data="ytd.losses" itemcol="Info" valuecol="Value"
						:url="'/fuel/report2?tab=1&plant=' + plant + '&' + this.getYTDfilter('dateStart', 'dateEnd') + '&detail1=station'"/>
				</div>
			</div>
				<div class="mb-4">
					<BarCard title="SALES WEEKLY (KL)" :data="sales.weekly" :width="500" :height="350"/>
				</div>
				<!--
				<div class="row mb-4">
					<BarCard title="SALES TODAY (KL)" :data="sales.hourly" :width="500" :height="280"/>
				</div>
				-->
				<div class="mb-4">
					<BarCard title="AVAILABLE STOCK (KL)" :data="tankStock" :width="500" :height="280"/>
				</div>
		</div>
		<div class="col-md-4">
			<div class="mb-4">
				<ListCompare title="REALISASI BBK" unit="%" comp=1 :data="ytd.bbk" itemcol="Info" valuecol="Value"
					:url="'/fuel/report2?tab=0&detail2=group&plant=' + plant + '&' + this.getYTDfilter('dateStart', 'dateEnd') + '&detail1=station'"/>
			</div>
			<div class="row mb-4">
				<ListItem warning=1 title="CRITICAL STOCK BY PRODUCT" :data="critical.product" itemcol="ProductName" valuecol="Cnt"
					:url="'/fuel/report2?tab=3&status=CRITICAL&plant=' + plant + '&detail1=station&detail2=product'"/>
			</div>
				<div class="mb-4">
					<div class="card">
						<div class="card-header p-3 pb-0 pt-2">
							<H6>PAYMENT YTD (B)</H6>
						</div>
						<div class="card-body p-3 pt-0" style="width:280px;">
							<PieChart :data="this.pieChartDataPayment" 
								:url="'/fuel/report2?tab=2&plant=' + plant + '&' + this.getYTDfilter('dateStart', 'dateEnd') + '&detail1=station'"/>
                        </div>
                    </div>
				</div>
				<div class="mb-4">
						<ListCompare title="CASH PERCENTAGE" unit="%" comp=-1 :data="ytd.pctcash" itemcol="Info" valuecol="Value"
							:url="'/fuel/report2?tab=2&plant=' + plant + '&' + this.getYTDfilter('dateStart', 'dateEnd') + '&detail1=station'"/>
				</div>
		</div>
		<!-- <div class="row">
			<h4>Status Pekerja</h4>
			<ReportResultTable reportname="CustomerComplaint" :reportdata="reportdata" />
		</div> -->
	</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import PieChart from '@/components/chart/Pie.js'
import { FuelColor } from '@/utility.js'

export default{
	extends: Fuel,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		PieChart,
	},
	data() {
		return {
			pieChartDataPayment: [],
		}
	},
    mounted() {
		this.loadYTD();
		this.loadCritical();
		this.loadSalesYTD();
		this.loadTankStock();
		//this.loadSalesHourly();
		this.loadLastTrans(10);
    },
	watch : {
		ytd() {
			this.setPieChartDataPayment();
		}
	},
	computed: {
		tankStock() {
			let data = [];
			for (let i=0;i<this.stock.tank.length;i++) {
				let dt2 = {}
				dt2.TankName = this.stock.tank[i].TankName;
				dt2.ProductName = this.stock.tank[i].ProductName;
				dt2.Volume = this.stock.tank[i].FuelVolume;
				data.push(dt2);
			}
			for (let i=0;i<this.stock.tank.length;i++) {
				let dt2 = {}
				dt2.TankName = this.stock.tank[i].TankName;
				dt2.ProductName = "ULLAGE";
				dt2.Volume = this.stock.tank[i].Ullage;
				data.push(dt2);
			}
			return this.processBarChart2(data, 'ProductName', 'Volume', false, 'TankName', 1000, 2, FuelColor, 
						false, false, false, true, false, false, false, false, true);
		}
	},
    methods:{
        setPieChartDataPayment(){
			var warna=[]
			warna["NON CASH"]='rgba(255,0,0,1)'
			warna["CASH"]='rgba(0,0,255,1)'				

			let result =  this.processPieChart(
				[
					{
						transtype: "CASH", 
						amount: this.getYTDItem(this.ytd.raw.cash, 1).AmountCash
					},
					{
						transtype: "NON CASH", 
						amount: this.getYTDItem(this.ytd.raw.cash, 1).AmountNonCash
					}
				], 
				"amount", "transtype", 1000000000, 2, warna); 
			
			this.pieChartDataPayment = result;
        }		
	}
}

</script>